const { decodeJwt } = require("jose");

const defaults = {
    storage: window.localStorage,
    accessTokenKey: 'access_token_lp',
    idTokenKey : 'id_token_lp',
    accessTokenInfo :'access_token_info_lp',
    user: 'user_lp'
};

function keepAccessToken(token) {
    defaults.storage.setItem(defaults.accessTokenKey, token);
    keepAccessTokenInfo(token);
}

function keepAccessTokenInfo() {
    var token = defaults.storage.getItem(defaults.accessTokenKey);
    var decodedtoken = readToken(token);
    var tokenDetails = {
        issuedAt: decodedtoken.iat,
        expiresAt: decodedtoken.exp
    };
    tokenDetails = JSON.stringify(tokenDetails);
    defaults.storage.setItem(defaults.accessTokenInfo, tokenDetails);
}

function keepIdToken(token) {
    defaults.storage.setItem(defaults.idTokenKey, token);
}

function keepUser(user) {
    if (!user) {
        throw 'user information not received';
    }
    defaults.storage.setItem(defaults.user, JSON.stringify(user));
}

function getAccessToken() {
    return defaults.storage.getItem(defaults.accessTokenKey);
}

function readAccessTokenInfo() {
    var accessTokenInfo = defaults.storage
                            .getItem(defaults.accessTokenInfo);
    try {
        return JSON.parse(accessTokenInfo);
    }
    catch (e) {
        return null;
    }
}

function readAccessToken() {
    var accessTokenInfo = defaults.storage
                            .getItem(defaults.accessTokenKey);
    return readToken(accessTokenInfo);
}

function getIdToken() {
    return defaults.storage.getItem(defaults.idTokenKey);
}

function readIdToken() {
    var idToken = defaults.storage
                            .getItem(defaults.idTokenKey);
    return readToken(idToken);
}

function readToken(token) {
    try {
        return decodeJwt(token);
    }
    catch (e) {
        return null;
    }
}

function getUser() {
    try {
        const user = defaults.storage.getItem(defaults.user);
        return JSON.parse(user);
    }
    catch (e) {
        return null;
    }
}

function forgetToken() {
    defaults.storage.removeItem(defaults.accessTokenKey);
    defaults.storage.removeItem(defaults.idTokenKey);
    defaults.storage.removeItem(defaults.user);
    defaults.storage.removeItem(defaults.accessTokenInfo);
}

export default {
    keepAccessToken : keepAccessToken,
    keepIdToken : keepIdToken,
    keepUser : keepUser,
    getAccessToken : getAccessToken,
    readAccessTokenInfo : readAccessTokenInfo,
    readAccessToken : readAccessToken,
    getIdToken : getIdToken,
    readIdToken : readIdToken,
    getUser : getUser,
    forgetToken : forgetToken
};